import { connect } from 'react-redux';

import Estimates from '../../components/instrument/Estimates';
import withTickerSubscribe from '../../hoc/withTickerSubscribe';
import normalizeSymbol from '../../service/normalizesymbol';

function mapStateToProps({ tickers }, { symbol }) {
    return tickers[normalizeSymbol(symbol)] || {};
}

export default connect(mapStateToProps)(
    withTickerSubscribe(Estimates),
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/instrument/Estimates.js
 **/